export enum BatchTypeEnum {
  vehicle = "vehicle",
  meterReading = "meterReading"
}
